import { useState, useCallback } from 'react';
/**
 * Hook for managing error/info modal state.
 */
export var useModal = function () {
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var _b = useState(''), message = _b[0], setMessage = _b[1];
    var openModal = useCallback(function (msg) {
        setMessage(msg);
        setIsOpen(true);
    }, []);
    var closeModal = useCallback(function () {
        setIsOpen(false);
    }, []);
    return { isOpen: isOpen, message: message, openModal: openModal, closeModal: closeModal };
};
